import { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import InlineSvg from '../InlineSvg'
import { formatCurrencyAlwaysSign } from '../../utils/money'
import RenderPendix from './../RenderPendix'
import { t } from '../../utils/i18n'
import { downloadImage } from '../../utils/local-image'
import { checkLack, getChoice } from '../../utils/bike-config'
import { getBaseModel, getComponent } from '../../utils/bike-schema'
import { bikeImageReload, optionClicked } from '../../actions'
import Popover from '../Popover'
import { BACKEND_URL, isDk, isEu, isDe } from '../../utils/settings'

const getNationalizedProductUrl = (option) => {
  if (
    option.id === 'tracker' ||
    option.id === 'silver-holder' ||
    option.id === 'velorbis-edrive-battery-frame-black' ||
    option.id === 'velorbis-edrive-battery-frame-brown'
  ) {
    if (isEu) return option.product_eu
    if (isDk) return option.product_dk
    if (isDe) return option.product_de
    else return option.product // fallback value
  } else return option.product
}

const ComponentHoverPopover = () => {
  const dispatch = useDispatch()
  const componentId = useSelector((state) => state.options?.componentId)
  const bikeConfig = useSelector((state) => state.bikeConfig)
  const lang = useSelector((state) => state.lang)
  const currencyCode = useSelector((state) => state.currencyCode)

  const baseModel = getBaseModel(bikeConfig.baseModelId)
  const component = getComponent(baseModel, componentId)
  const choice = getChoice(bikeConfig, component)
  const currentPrice = choice.option.price
    ? choice.option.prices[currencyCode]
    : 0
  const options = component.options
  const name = component.name[lang]

  const optionList = options
    .map((option) => {
      if (option.hidden) return null
      // TODO: refactor this uglyness
      return [
        option.name[lang],
        option.id,
        componentId,
        (option.price ? option.prices[currencyCode] : 0) - currentPrice,
        option.sold,
        getNationalizedProductUrl(option)
      ]
    })
    .filter((el) => el != null)

  const isLack = checkLack(component.prompt, optionList)
  const [visible, setVisible] = useState(false)

  const handleClick = (opt) => {
    if (opt[4] === undefined) {
      dispatch(optionClicked(opt[2], opt[1]))
      dispatch(bikeImageReload())
    }
  }

  const isDk = window.location.hostname.endsWith('s.dk')
  const displayTooltip = visible

  return (
    <Popover
      className="velorbis-customizer-color-picker"
      minWidth={'250px'}
      alignTo={`.velorbis-customizer-component[data-component="${componentId}"]`}
    >
      <div className="velorbis-customizer-popover-header">
        {`${name} options`}
        {componentId === 'electric-motor' && (
          <div className="inline-block">
            <div className="download-icon" onClick={downloadImage}>
              <InlineSvg src="icons/download" />
              <div></div>
            </div>
            <div className="tooltip" onMouseEnter={() => setVisible(true)}>
              &#9432;
            </div>
          </div>
        )}
      </div>
      {displayTooltip && (
        <div className="tooltip-content">
          <div className="pendix-wrapper">
            <button className="close-button" onClick={() => setVisible(false)}>
              X
            </button>
            <RenderPendix />
          </div>
        </div>
      )}
      <div className="velorbis-customizer-popover-body velorbis-customizer-hover-popover">
        {isLack ? (
          <div>{t(`${component.id}_prompt`)}</div>
        ) : (
          optionList.map((opt) => {
            let displayProductLink = opt[5]
            return (
              <div
                className="velorbis-customizer-hover-popover-item-wrapper"
                key={opt[1]}
              >
                <div
                  className={`velorbis-customizer-hover-popover-item ${
                    opt[4] ? 'velorbis-customizer-hover-popover-item-sold' : ''
                  }`}
                  onClick={() => handleClick(opt)}
                >
                  <div className="velorbis-customizer-hover-popover-item-title">
                    {opt[0]}
                  </div>
                  <div className="velorbis-customizer-hover-popover-item-content">
                    <img
                      className="velorbis-customizer-hover-popover-image"
                      src={`${BACKEND_URL}/images/thumbnails/${opt[2]}/${opt[1]}.png`}
                      alt={opt[1]}
                    />
                    {opt[4] ? (
                      <div className="velorbis-customizer-sold-out">
                        Sold out!
                      </div>
                    ) : (
                      !component.hide_price && (
                        <div>
                          {formatCurrencyAlwaysSign(opt[3], currencyCode)}
                        </div>
                      )
                    )}
                  </div>
                </div>
                {displayProductLink && (
                  <a
                    className="product-link"
                    href={opt[5]}
                    rel="noreferrer"
                    target="_blank"
                  >
                    {t('add_product_link')}
                  </a>
                )}
              </div>
            )
          })
        )}
      </div>
    </Popover>
  )
}

export default ComponentHoverPopover
